// Import product images
import offsetHero from "@/assets/products/offset-hero.webp";
import rosaliaOak1 from "@/assets/products/rosalia-oak-01.webp";
import rosaOak1 from "@/assets/products/rosa-oak-01.webp";
import medusaSandoak1 from "@/assets/products/medusa-sandoak-01.webp";
import normaSandoak1 from "@/assets/products/norma-sandoak-01.webp";
import normusOak1 from "@/assets/products/normus-oak-01.webp";
import eratoSandoak1 from "@/assets/products/erato-sandoak-01.webp";
import echoSandoak1 from "@/assets/products/echo-sandoak-01.webp";
import voiceOak1 from "@/assets/products/voice-oak-01.webp";
import deltaSandoak1 from "@/assets/products/delta-sandoak-01.webp";
import terraOak1 from "@/assets/products/terra-oak-01.webp";
import arcticaGrey1 from "@/assets/products/arctica-grey-01.webp";
import milano1 from "@/assets/products/milano-01.webp";
import maestro1 from "@/assets/products/maestro-01.webp";
import uplift1 from "@/assets/products/uplift-01.webp";
import nubia1 from "@/assets/products/nubia-01.webp";
import nero1 from "@/assets/products/nero-01.webp";
import pocketOak1 from "@/assets/products/pocket-oak-01.webp";
import zenOak1 from "@/assets/products/zen-oak-01.webp";
import kyotoOak1 from "@/assets/products/kyoto-oak-01.webp";
import haloBlack1 from "@/assets/products/halo-black-01.webp";
import gemMarble1 from "@/assets/products/gem-marble-01.webp";
import cloudOak1 from "@/assets/products/cloud-oak-01.webp";
import ariaOak1 from "@/assets/products/aria-oak-01.webp";
import skyOak1 from "@/assets/products/sky-oak-01.webp";
import porta1 from "@/assets/products/porta-01.webp";
import clare1 from "@/assets/products/clare-01.webp";
import velvet1 from "@/assets/products/velvet-01.webp";
import focus1 from "@/assets/products/focus-01.webp";
import viva1 from "@/assets/products/viva-01.webp";
import basis1 from "@/assets/products/basis-01.webp";
import fluto1 from "@/assets/products/fluto-01.webp";
import verse1 from "@/assets/products/verse-01.webp";
import key1 from "@/assets/products/key-01.webp";
import nomaOak1 from "@/assets/products/noma-oak-01.webp";
import lago1 from "@/assets/products/lago-01.webp";
import radius1 from "@/assets/products/radius-01.webp";
import ronda1 from "@/assets/products/ronda-01.webp";
import frame1 from "@/assets/products/frame-01.webp";
import omnia1 from "@/assets/products/omnia-01.webp.asset.json";

export interface Product {
  id: number;
  name: string;
  slug: string;
  price: number;
  image: string;
  dimensions: string;
  material: string;
  stock: "Na zalogi" | "Po naročilu";
  category: string;
}

export const products: Product[] = [
  {
    id: 1,
    name: "Raztegljiva miza Offset",
    slug: "offset",
    price: 1700,
    image: offsetHero,
    dimensions: "Ø 130 cm / Ø 180 cm",
    material: "ALPI SAND OAK, jeklo",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 2,
    name: "Raztegljiva miza Rosalia",
    slug: "rosalia",
    price: 1490,
    image: rosaliaOak1,
    dimensions: "140 x 90 cm / 180 x 90 cm",
    material: "Hrast",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 3,
    name: "Raztegljiva miza Rosa",
    slug: "rosa",
    price: 1895,
    image: rosaOak1,
    dimensions: "140 x 90 cm / 180 x 90 cm",
    material: "Hrast",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 4,
    name: "Raztegljiva miza Medusa",
    slug: "medusa",
    price: 2495,
    image: medusaSandoak1,
    dimensions: "Ø 120 cm / Ø 160 cm",
    material: "Peščeni hrast / Črni hrast",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 5,
    name: "Raztegljiva miza Norma",
    slug: "norma",
    price: 1795,
    image: normaSandoak1,
    dimensions: "Ø 120 cm / Ø 160 cm",
    material: "Peščeni hrast / Belo",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 6,
    name: "Raztegljiva miza Normus",
    slug: "normus",
    price: 1795,
    image: normusOak1,
    dimensions: "Ø 120 cm / Ø 160 cm",
    material: "Hrast natur / Črni hrast",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 7,
    name: "Raztegljiva miza Erato",
    slug: "erato",
    price: 1760,
    image: eratoSandoak1,
    dimensions: "Ø 120 cm / Ø 160 cm",
    material: "Peščeni hrast / Belo",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 8,
    name: "Raztegljiva miza Echo",
    slug: "echo",
    price: 1795,
    image: echoSandoak1,
    dimensions: "160 x 90 cm / 210 x 90 cm",
    material: "Peščeni hrast / Črna",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 9,
    name: "Raztegljiva miza Voice",
    slug: "voice",
    price: 2295,
    image: voiceOak1,
    dimensions: "180 x 90 cm / 240 x 90 cm",
    material: "Hrast natur / Črna",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 10,
    name: "Raztegljiva miza Delta",
    slug: "delta",
    price: 2295,
    image: deltaSandoak1,
    dimensions: "180 x 90 cm / 240 x 90 cm",
    material: "Peščeni hrast / Belo",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 11,
    name: "Miza Terra",
    slug: "terra",
    price: 1650,
    image: terraOak1,
    dimensions: "Ø 120 cm",
    material: "Hrast masiva",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 12,
    name: "TV element Arctica",
    slug: "arctica",
    price: 0,
    image: arcticaGrey1,
    dimensions: "Po meri",
    material: "Furnir: ALPI Sottsass Grey",
    stock: "Po naročilu",
    category: "TV elementi",
  },
  {
    id: 13,
    name: "Walk-in garderoba Milano",
    slug: "milano",
    price: 0,
    image: milano1,
    dimensions: "Po meri",
    material: "Furnir, LED osvetlitev",
    stock: "Po naročilu",
    category: "Garderobe",
  },
  {
    id: 14,
    name: "Jedilna miza Maestro",
    slug: "maestro",
    price: 2499,
    image: maestro1,
    dimensions: "Po meri",
    material: "Alpi furnir Sand oak, Travertine Laminam",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 15,
    name: "Postelja Uplift",
    slug: "uplift",
    price: 0,
    image: uplift1,
    dimensions: "Po meri",
    material: "Svetli hrast",
    stock: "Po naročilu",
    category: "Postelje",
  },
  {
    id: 16,
    name: "TV element Nubia",
    slug: "nubia",
    price: 0,
    image: nubia1,
    dimensions: "Po meri",
    material: "Furnir, LED osvetlitev",
    stock: "Po naročilu",
    category: "TV elementi",
  },
  {
    id: 17,
    name: "Garderoba Nero",
    slug: "nero",
    price: 0,
    image: nero1,
    dimensions: "Po meri",
    material: "Furnir, steklena vrata, LED osvetlitev",
    stock: "Po naročilu",
    category: "Garderobe",
  },
  {
    id: 18,
    name: "Garderoba Pocket",
    slug: "pocket",
    price: 0,
    image: pocketOak1,
    dimensions: "Po meri",
    material: "Mehanizem Hawa Concepta, Blum Revego",
    stock: "Po naročilu",
    category: "Garderobe",
  },
  {
    id: 19,
    name: "Postelja Zen",
    slug: "zen",
    price: 0,
    image: zenOak1,
    dimensions: "Po meri",
    material: "Furnir svetli hrast, oblazinjeno vzglavje, LED osvetlitev",
    stock: "Po naročilu",
    category: "Postelje",
  },
  {
    id: 20,
    name: "Postelja Kyoto",
    slug: "kyoto",
    price: 0,
    image: kyotoOak1,
    dimensions: "Po meri",
    material: "Furnir svetli hrast, oblazinjeno vzglavje, LED osvetlitev",
    stock: "Po naročilu",
    category: "Postelje",
  },
  {
    id: 21,
    name: "Klubska mizica Halo",
    slug: "halo",
    price: 0,
    image: haloBlack1,
    dimensions: "Ø 50 cm, V: 40 cm",
    material: "Masivni hrast, črna",
    stock: "Po naročilu",
    category: "Klubske mizice",
  },
  {
    id: 22,
    name: "TV element Gem",
    slug: "gem",
    price: 0,
    image: gemMarble1,
    dimensions: "Po meri",
    material: "Bel lak, marmor Saint Laurent",
    stock: "Po naročilu",
    category: "TV elementi",
  },
  {
    id: 23,
    name: "Postelja Cloud",
    slug: "cloud",
    price: 0,
    image: cloudOak1,
    dimensions: "Po meri",
    material: "Furnir svetli hrast, oblazinjeno vzglavje, LED osvetlitev",
    stock: "Po naročilu",
    category: "Postelje",
  },
  {
    id: 24,
    name: "Miza Aria",
    slug: "aria",
    price: 1595,
    image: ariaOak1,
    dimensions: "Ø 120 cm",
    material: "Hrast natur",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 25,
    name: "Postelja Sky",
    slug: "sky",
    price: 0,
    image: skyOak1,
    dimensions: "Po meri",
    material: "Furnir hrast, LED osvetlitev",
    stock: "Po naročilu",
    category: "Postelje",
  },
  {
    id: 26,
    name: "Recepcijski pult Porta",
    slug: "porta",
    price: 0,
    image: porta1,
    dimensions: "Po meri",
    material: "MDF, barvano po RAL karti",
    stock: "Po naročilu",
    category: "Recepcijski pulti",
  },
  {
    id: 27,
    name: "Recepcijski pult Clare",
    slug: "clare",
    price: 0,
    image: clare1,
    dimensions: "Po meri",
    material: "MDF, barvano po RAL karti",
    stock: "Po naročilu",
    category: "Recepcijski pulti",
  },
  {
    id: 28,
    name: "Lepotilna mizica Velvet",
    slug: "velvet",
    price: 0,
    image: velvet1,
    dimensions: "Š: 100 cm, G: 45 cm, V: 78 cm",
    material: "MDF barvano, kovinsko podnožje",
    stock: "Po naročilu",
    category: "Lepotilna mizica",
  },
  {
    id: 29,
    name: "Pisalna miza Focus",
    slug: "focus",
    price: 0,
    image: focus1,
    dimensions: "Po meri",
    material: "Furnir hrast natur",
    stock: "Po naročilu",
    category: "Pisalne mize",
  },
  {
    id: 30,
    name: "Miza Viva",
    slug: "viva",
    price: 0,
    image: viva1,
    dimensions: "Ø 120 cm",
    material: "Hrast natur",
    stock: "Po naročilu",
    category: "Mize",
  },
  {
    id: 31,
    name: "Garderoba Basis",
    slug: "basis",
    price: 0,
    image: basis1,
    dimensions: "Po meri",
    material: "Antracit, LED osvetlitev",
    stock: "Po naročilu",
    category: "Garderobe",
  },
  {
    id: 32,
    name: "Recepcijski pult Fluto",
    slug: "fluto",
    price: 0,
    image: fluto1,
    dimensions: "Po meri",
    material: "MDF rebrasta fronta, orehova plošča, medenina",
    stock: "Po naročilu",
    category: "Recepcijski pulti",
  },
  {
    id: 33,
    name: "Regal Verse",
    slug: "verse",
    price: 0,
    image: verse1,
    dimensions: "Po meri",
    material: "MDF barvano, push-to-open",
    stock: "Po naročilu",
    category: "Regali",
  },
  {
    id: 34,
    name: "Garderoba Key",
    slug: "key",
    price: 0,
    image: key1,
    dimensions: "Po meri",
    material: "Siva lak, hrast, steklena vrata, LED osvetlitev",
    stock: "Po naročilu",
    category: "Garderobe",
  },
  {
    id: 35,
    name: "Pisalna miza Noma",
    slug: "noma",
    price: 0,
    image: nomaOak1,
    dimensions: "Po meri",
    material: "Furnir hrast natur, filc obloga",
    stock: "Po naročilu",
    category: "Pisalne mize",
  },
  {
    id: 36,
    name: "TV element Lago",
    slug: "lago",
    price: 0,
    image: lago1,
    dimensions: "Po meri",
    material: "Lakirana površina, hrastov rebrasti panel, LED osvetlitev",
    stock: "Po naročilu",
    category: "TV elementi",
  },
  {
    id: 37,
    name: "Garderoba Radius",
    slug: "radius",
    price: 0,
    image: radius1,
    dimensions: "Po meri",
    material: "MDF lakirano modro sivo, zaobljeni elementi",
    stock: "Po naročilu",
    category: "Garderobe",
  },
  {
    id: 38,
    name: "TV element Ronda",
    slug: "ronda",
    price: 0,
    image: ronda1,
    dimensions: "Po meri",
    material: "Furnir svetli hrast, LED osvetlitev",
    stock: "Po naročilu",
    category: "TV elementi",
  },
  {
    id: 39,
    name: "TV element Frame",
    slug: "frame",
    price: 0,
    image: frame1,
    dimensions: "Po meri",
    material: "Furnir svetli hrast, drsna vrata, LED osvetlitev",
    stock: "Po naročilu",
    category: "TV elementi",
  },
  {
    id: 40,
    name: "Miza Omnia",
    slug: "omnia",
    price: 0,
    image: omnia1.url,
    dimensions: "Po meri",
    material: "Hrast natur",
    stock: "Po naročilu",
    category: "Mize",
  },
];
